import {
    AfterViewChecked,
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { BusinessOwner } from 'src/app/acl-data/business-owner/business-owner.dto';
import { BusinessOwnerService } from 'src/app/acl-data/business-owner/business-owner.service';
import { SubSink } from 'subsink';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { BOUploadComponent } from '../bo-upload/bo-upload.component';

@Component({
    templateUrl: './business-owner-list.component.html',
    styleUrls: ['./business-owner-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusinessOwnerListComponent implements OnInit, OnDestroy {
    subSink = new SubSink();
    businessOwners;

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    loading$ = this.businessOwnerService.loading$;
    dataSource;

    displayedColumns: string[] = [
        'fullname',
        'email',
        'department',
        'designation',
        'telephone',
        'active',
    ];

    constructor(
        private router: Router,
        private businessOwnerService: BusinessOwnerService,
        private dialog: MatDialog
    ) {}

    ngOnDestroy(): void {
        this.subSink.unsubscribe();
    }

    ngOnInit(): void {
        this.subSink.add(
            this.businessOwnerService
                .getAll()
                .pipe(
                    map(v =>
                        v.sort((a, b) => (a.fullname > b.fullname ? 1 : -1))
                    )
                )
                .subscribe(v => {
                    this.businessOwners = v;
                    if (this.businessOwners && this.businessOwners.length > 0) {
                        this.dataSource = new MatTableDataSource<BusinessOwner>(
                            this.businessOwners
                        );

                        this.dataSource.paginator = this.paginator;
                        this.dataSource.sort = this.sort;
                        console.log(this.sort);
                    }
                })
        );
    }

    download = () => {
        console.log('Downloading');
        this.businessOwnerService.downloadAll().subscribe(
            response => {
                this.downLoadFile(
                    response,
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Business Owner Master Data.xlsx'
                );
            },
            error => {
                console.log('Error', error);
            }
        );
    };

    upload = (fileValue?: any) => {
        console.log('Uploading');
        const dialogRef = this.dialog.open(BOUploadComponent, {
            data: {},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                console.log('The dialog was closed', result);
            }
        });
    };

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    /**
     * Method is use to download file.
     * @param data - Array Buffer data
     * @param type - type of the document.
     */
    downLoadFile(data: any, typeValue: string, filename: string) {
        console.log('Download Data');
        // const blob = new Blob([data], { type: typeValue });
        // const url = window.URL.createObjectURL(blob);
        // window.location.href = url;

        const a = document.createElement('a');
        document.body.appendChild(a);
        // a.style = 'display: none';

        const blob = new Blob([data], { type: typeValue });
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        // const pwa = window.open(url);
        // if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
        //     alert('Please disable your Pop-up blocker and try again.');
        // }
    }
}
